var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBackDesk(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6 12C6.01104 11.4541 6.19871 11.0066 6.65133 10.5808L14.9972 2.49127C15.3395 2.16376 15.7369 2 16.2226 2C17.1941 2 18 2.78603 18 3.73581C18 4.21616 17.7902 4.66376 17.4259 5.0131L10.1509 11.9891L17.4259 18.976C17.7902 19.3362 18 19.7729 18 20.2642C18 21.2249 17.1941 22 16.2226 22C15.7369 22 15.3395 21.8362 14.9972 21.5087L6.65133 13.4192C6.19871 12.9825 6 12.5349 6 12Z",
    fill: "#9C85F6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackDesk);
export default __webpack_public_path__ + "static/media/back-desk.c39865d23d7eac23719f722997ecebc2.svg";
export { ForwardRef as ReactComponent };